export default __webpack_public_path__ + "static/media/ecc-logo-180.8893e96d.png";